import { observer } from 'mobx-react-lite'
import { type ITabItem, Tabs } from 'shared/ui'
import { PageDescription } from 'pages/settings/ui/PageDescription/PageDescription'
import { NextButton } from 'pages/settings/ui/NextButton/NextButton'
import { useRcsWizardContext } from 'pages/settings/pages/rcsV2/context/rcsWizardContext'
import { RcsWizardSteps } from 'pages/settings/pages/rcsV2/route/type'
import { FindBusiness } from './FindBusiness'
import { ManualBusinessForm } from './ManualBusinessForm'

import styles from './styles.module.scss'

const TABS: ITabItem<'find' | 'manual'>[] = [
  { name: 'Find your business', key: 'find' },
  { name: 'Enter manually', key: 'manual' },
]

export const BusinessInfo = observer(() => {
  const {
    saving,
    nextStepClick,
    businessInfoStore: { activeTab, setActiveTab, isNextDisabled },
  } = useRcsWizardContext()

  const onNext = () => nextStepClick(RcsWizardSteps.businessInfo)

  return (
    <div className={styles.wrap}>
      <PageDescription>Enter your business details for carrier verification</PageDescription>

      <Tabs
        tabs={TABS}
        activeTabKey={activeTab}
        handleSelectTab={(tab) => setActiveTab(tab.key)}
        tabsClassName={styles.tabs}
        margin='40px 0 28px'
      />

      {activeTab === 'find' ? <FindBusiness /> : <ManualBusinessForm />}

      <NextButton
        text='Next'
        disabled={isNextDisabled || saving}
        loading={saving}
        onClick={onNext}
      />
    </div>
  )
})
